// import httpClient from './httpClientDebug'
import httpClient from './httpClient'

const END_POINT = '/customerresources'
// const END_POINT = ''

const CampaignAPI = {
  createBuyerCampaign({ accountId, campaign }) {
    return httpClient.post(`${END_POINT}/${accountId}/buyer-campaigns`, campaign)
  },

  // eslint-disable-next-line no-unused-vars
  editBuyerCampaign({ accountId, campaign }) {
    return httpClient.patch(`${END_POINT}/${accountId}/buyer-campaigns/${campaign.id}`, campaign)
  },

  listBuyerCampaigns(accountId) {
    return httpClient.get(`${END_POINT}/${accountId}/buyer-campaigns`)
  },

  getBuyerCampaign(accountId, id) {
    return httpClient.get(`${END_POINT}/${accountId}/buyer-campaigns/${id}`)
  },

  pauseBuyerCampaign({ accountId, campaignId }) {
    return httpClient.put(`${END_POINT}/${accountId}/buyer-campaigns/${campaignId}/pause`)
  },

  resumeBuyerCampaign({ accountId, campaignId }) {
    return httpClient.put(`${END_POINT}/${accountId}/buyer-campaigns/${campaignId}/resume`)
  },

  pauseSellerCampaign({ campaignId }) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({ id: campaignId })
      }, 3000)
    })
  },

  resumeSellerCampaign({ campaignId }) {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve({ id: campaignId })
      }, 3000)
    })
  },

  // PUT .../update-bid, 200 with an empty body on success.
  // The request body field is `value` (BuyerCampaignUpdateBidRequest.Value in the backend),
  // NOT `bidAmount` as the published openapi.yaml incorrectly documents it - `value` is a
  // non-nullable float server-side, so a `bidAmount` body silently binds to 0 and 200s.
  updateCampaignBid({ accountId, campaignId, bidValue }) {
    return httpClient.put(`${END_POINT}/${accountId}/buyer-campaigns/${campaignId}/update-bid`, {
      campaignId,
      value: bidValue
    })
  },

  async uploadZipCodesFile({accountId, file}) {    
    const formData = new FormData()
    formData.append('ZipCodesFile', file)  
    return await httpClient.post(`${END_POINT}/${accountId}/buyer-campaigns/zip-codes`, formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }
    )
  }
}

export default CampaignAPI
